import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    title: 'Software Development',
    description: 'Innovative software solutions tailored to your business needs.',
    icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" /></svg>
    ),
    path: '/services/7'
  },
  {
    title: 'Web Development',
    description: 'Robust web apps crafted for performance & user engagement.',
    icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9V3m0 18a9 9 0 00-9-9m9 9a9 9 0 00-9-9" /></svg>
    ),
    path: '/services/8'
  },
  {
    title: 'Mobile App Development',
    description: 'Custom mobile apps built for performance and reliability.',
    icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg>
    ),
    path: '/services/9'
  },
  {
    title: 'UI/UX Design',
    description: 'Intuitive designs focused on enhancing user interaction.',
    icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg>
    ),
    path: '/services/10'
  },
  {
    title: 'AI Driven Solutions',
    description: 'Harness AI to drive smarter business decisions and automation.',
    icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 4v5h5M20 20v-5h-5M4 4l5 5M20 20l-5-5" /></svg>
    ),
    path: '/ai-solutions'
  },
  {
    title: 'SaaS Product Development',
    description: 'Scalable SaaS solutions for modern business challenges.',
    icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" /></svg>
    ),
    path: '/services/12'
  },
];

const OurServicesSection = () => {
  const scrollToHero = () => {
    document.getElementById('hero-section').scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <section className="bg-gradient-to-tr from-black to-[#264864] py-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white">Our Core Services</h2>
          <p className="text-lg text-gray-300 mt-2">We provide the expertise you need to succeed.</p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          
          {/* Left 6 cells */}
          <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {services.map((service) => (
              <Link to={service.path} key={service.title} className="relative border border-gray-700 p-6 rounded-lg h-48 flex flex-col bg-white/5 hover:bg-white/10 transition-colors duration-300 cursor-pointer">
                <h3 className="text-xl font-bold text-white mb-2">{service.title}</h3>
                <p className="text-gray-400 text-sm flex-grow">{service.description}</p>
                <div className="absolute bottom-4 right-4 text-gray-600">
                  {service.icon}
                </div>
              </Link>
            ))}
          </div>

          {/* Right narrow column */}
          <div 
            className="lg:col-span-1 rounded-lg bg-cover bg-center flex flex-col items-center justify-center text-center p-6 transition-all duration-300"
            style={{ backgroundImage: `url('/img/services3.png')` }}
          >
            <h3 className="text-2xl font-bold text-white">Build Your Next Idea</h3>
            <p className="text-gray-300 mt-2 mb-6">Let's turn your vision into a reality.</p>
            <button
              onClick={scrollToHero}
             className="flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-300">
                Start Now
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" /></svg>
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default OurServicesSection;